import { createSlice } from '@reduxjs/toolkit';

const formationsSlice = createSlice({
  name: 'formationsNav',
  initialState: {
    activeTab: true, // Por defecto activos
    activeBtn: 'activos'
  },
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setActiveBtn:(state, action) => {
      state.activeBtn = action.payload;
    }
  },
});

export const { setActiveTab,setActiveBtn } = formationsSlice.actions;
export default formationsSlice.reducer;